export enum DealFrequency {
    High = 'high',
    Medium = 'medium',
    Low = 'low'
}

export enum DealFrequencyStyleClass {
    High = 'deal-frequency-high',
    Medium = 'deal-frequency-medium',
    Low = 'deal-frequency-low'
}

export const DEAL_FREQUENCY_CLASS_MAP: Record<DealFrequency, DealFrequencyStyleClass> = {
    [DealFrequency.High]: DealFrequencyStyleClass.High,
    [DealFrequency.Medium]: DealFrequencyStyleClass.Medium,
    [DealFrequency.Low]: DealFrequencyStyleClass.Low
};

export interface Airport {
    id: number;
    cityId: number;
    cityName: string;
    code: string;
    name: string;
    country: string;
    image?: string;
    dealFrequency: DealFrequency | null;
    city: {
        id: number;
        name: string;
        images: Array<{
            id: number;
            urlOriginal: string;
            srcset: string;
            sizes: string;
            altText: string;
            photographerName: string;
            photographerUrl: string;
            sortOrder: number;
        }>;
    };
}

/** rank 0 is the user's primary (home) airport; the rest follow in the order they were added. */
export interface UserDeparture extends Airport {
    rank: number;
}

/** Update of one of the user's departures; mirrors the backend's departure update endpoint. */
export interface UserDepartureUpdate {
    rank: number;
}


export interface Destination {
    id: number;
    name: string;
    image: string;
    country: { id: number, name: string };
    airports: { code: string }[];
    images: Array<{
        id: number;
        urlOriginal: string;
        srcset: string;
        sizes: string;
        altText: string;
        photographerName: string;
        photographerUrl: string;
        sortOrder: number;
    }>;
    photographerName?: string;
    photographerLink?: string;
    stateName?: string;
    selected?: boolean;
    order?: number | null;
}
